const HeaderBar = ({ pageHeader, children = null }: any) => {
  return (
    <header className="cht-flex cht-flex-col sm:cht-flex-row cht-items-center sm:cht-items-center cht-justify-between cht-gap-6 sm:cht-gap-0 cht-px-4 sm:cht-px-6 cht-py-4 sm:cht-py-6 cht-bg-[#f2f4fd]/80 cht-backdrop-blur-md cht-border-b cht-border-gray-200/40">
      <h1 className="cht-text-xl sm:cht-text-2xl cht-font-black cht-text-black cht-tracking-tight cht-text-center sm:cht-text-left">{pageHeader}</h1>
      <section className="cht-flex cht-items-center cht-justify-center sm:cht-justify-start cht-gap-4 cht-w-full sm:cht-w-auto">
        {children}
      </section>
    </header>
  );
};

export default HeaderBar;
